import React, { useState } from 'react';
import { Typography, TileGroup, Tile, DrawerBody, LoadingButton, Button, DrawerFooter, } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import { getWindow } from '../../../utils/general';
import { useExperienceContext } from '../../../hooks/useContexts';
export var EditDeliveryAddressDeliveryOptions = function (_a) {
    var _b;
    var closeDrawer = _a.closeDrawer;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isIos = (_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var _c = useState(''), selectedDeliveryOption = _c[0], setSelectedDeliveryOption = _c[1];
    // Mock data, to be implemented.
    var deliveryOptions = [
        {
            id: 1,
            title: 'Get it by Today',
            deliveryCost: 'FREE',
        },
        {
            id: 2,
            title: 'Scheduled Delivery (Outside)',
            deliveryCost: '+\u2060$2.99',
            label: 'Get it Today',
            description: 'You can select a specific date for your items to be delivered, require a signature, and leave notes for the driver.',
        },
    ];
    var handleChange = function (_event, id) {
        setSelectedDeliveryOption(id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                React.createElement(Typography, null, "Your delivery options have been updated based on your new delivery address."),
                React.createElement(TileGroup, { value: selectedDeliveryOption, onChange: handleChange, "aria-label": "rate", className: "sui-flex sui-flex-col sui-gap-5" }, deliveryOptions === null || deliveryOptions === void 0 ? void 0 : deliveryOptions.map(function (item) { return (React.createElement(Tile, { key: item.id, value: item.id, "aria-label": "delivery-address-tile", grow: true },
                    React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-between sui-gap-4 sui-w-full sui-p-3" },
                        React.createElement("div", { className: "sui-min-w-0 sui-max-w-full sui-break-words" },
                            React.createElement("div", { className: (item === null || item === void 0 ? void 0 : item.label) && 'sui-mb-1' },
                                React.createElement(Typography, { align: "left", weight: "bold", variant: "h5", height: "tight" }, item.title)),
                            React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-1" },
                                (item === null || item === void 0 ? void 0 : item.label) && (React.createElement(Typography, { align: "left" }, item.label)),
                                (item === null || item === void 0 ? void 0 : item.description) && (React.createElement(Typography, { align: "left" }, item.description)))),
                        React.createElement(Typography, { weight: "bold", color: item.deliveryCost === 'FREE' ? 'success' : 'none' }, item.deliveryCost)))); })))),
        React.createElement(DrawerFooter, { id: "drawer-footer-z-index-fix", className: "sui-bottom-auto sui-p-4" },
            React.createElement("div", { className: "card-fix sui-pb-2" },
                React.createElement(LoadingButton, { "data-testid": "confirm-changes-button" }, "Continue")),
            React.createElement("div", { className: classNames('card-fix', {
                    'ios-bottom-fix': isIosMobile,
                }) },
                React.createElement(Button, { variant: "secondary", onClick: function () { return closeDrawer(); } }, "Cancel")))));
};
